export default "__VITE_ASSET__2QJg2OeF__"